import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ILocalAuthPolicyPararms {
}

export interface ILocalAuthPolicyResult  extends IResult {
    isMaximumPasswordLengthPolicyEnabled: boolean;
    maximumPasswordLength: number;
    isMinimumPasswordLengthPolicyEnabled: boolean;
    minimumPasswordLength: number;
    isMustContainLettersPolicyEnabled: boolean;
    isMustContainNumbersPolicyEnabled: boolean;
    isMustContainSymbolsPolicyEnabled: boolean;
    isMustContainUppercasePolicyEnabled: boolean;
}

export class GetLocalAuthConfigurationRequest extends Request<ILocalAuthPolicyPararms, ILocalAuthPolicyResult> {
  constructor(params: ILocalAuthPolicyPararms = {}) {
    super('getLocalAuthenticationConfiguration', params);
  }
}
